import React from 'react'
import { sanitizeHtml } from '../../utils/Tools'

interface LabelHtmlRenderProps {
  customText: string;
}

const LabelHtmlRender = (props: LabelHtmlRenderProps) => {
  return(
    <span dangerouslySetInnerHTML={{__html: sanitizeHtml(props.customText)}}>
      
    </span>
  )
}

export default LabelHtmlRender